import { v4 as uuid } from 'uuid';
import { getGameInfoFromUrl } from '../ApiIntegration/ApiIntegration';

export const getGameSpecificStorageKey = (): string => {
  try {
    const url = window.location.href;
    const gameIdMatch = url.match(/\/games\/game\/[^/]+\/([^/]+)\//); 
    const gameId = gameIdMatch ? gameIdMatch[1] : null;

    if (!gameId) {
      console.warn('Could not extract game ID from URL, using fallback');
      return `gameProgress_${uuid()}`;
    }

    return `gameProgress_${gameId}`;
  } catch (error) {
    console.warn('Failed to generate game-specific storage key, using fallback:', error);
    return `gameProgress_${uuid()}`;
  }
};

export const saveProgressSafely = (storageKey: string, data: any): boolean => {
  try {
    localStorage.setItem(storageKey, JSON.stringify(data));
    return true;
  } catch (error) {
    console.error('Failed to save progress to localStorage:', error);
    return false;
  }
};

export const loadProgressSafely = (storageKey: string, defaultProgress: any): any => {
  try {
    const savedData = localStorage.getItem(storageKey);
    if (!savedData) {
      return defaultProgress;
    }

    const progress = JSON.parse(savedData);

    const validatedProgress = {
      ...defaultProgress,
      ...progress
    };

    if (!Array.isArray(validatedProgress.completedLevels)) {
      validatedProgress.completedLevels = [];
    }

    if (typeof validatedProgress.unlockedLevel !== 'number') {
      validatedProgress.unlockedLevel = defaultProgress.unlockedLevel;
    }

    if (typeof validatedProgress.levelScores !== 'object' || validatedProgress.levelScores === null) {
      validatedProgress.levelScores = {};
    }

    if (typeof validatedProgress.levelStars !== 'object' || validatedProgress.levelStars === null) {
      validatedProgress.levelStars = {};
    }

    return validatedProgress;

  } catch (error) {
    console.error('Failed to load progress from localStorage, using defaults:', error);
    try {
      localStorage.removeItem(storageKey);
    } catch (cleanupError) {
      console.error('Failed to clean up corrupted localStorage:', cleanupError);
    }
    return defaultProgress;
  }
};

export const clearProgressSafely = (storageKey: string): boolean => {
  try {
    localStorage.removeItem(storageKey);
    return true;
  } catch (error) {
    console.error('Failed to clear progress from localStorage:', error);
    return false;
  }
};